import { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import CustomToolTip from '../../../styles/CustomToolTip';
import { ABDM_MIN_ADDRESSES } from '../../../utils/constants';

const MapSummary = ({
  totalAddresses,
  totalCostWithoutDiscount,
  totalDiscount,
  totalCost,
  quantityUntilNextDiscount,
}) => {
  const [open, setOpen] = useState(false);

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const flexBoxContainer = {
    display: 'flex',
    justifyContent: 'space-between',
    borderRadius: 1,
  };

  useEffect(() => {}, [
    totalAddresses,
    totalCostWithoutDiscount,
    totalDiscount,
    totalCost,
    quantityUntilNextDiscount,
  ]);

  return (
    <Stack direction="column" spacing={1}>
      {totalAddresses > ABDM_MIN_ADDRESSES && (
        <>
          <Box sx={flexBoxContainer}>
            <Typography>
              {totalAddresses ? totalAddresses : 0} Addresses
            </Typography>
            <Typography>
              {totalCostWithoutDiscount ? totalCostWithoutDiscount : '$0'}
            </Typography>
          </Box>
          <Box sx={flexBoxContainer}>
            <Stack direction="row" spacing={1}>
              <Typography variant="body1">Volume Discount</Typography>
              <ClickAwayListener onClickAway={handleTooltipClose}>
                <div>
                  <CustomToolTip
                    PopperProps={{
                      disablePortal: true,
                    }}
                    onClose={handleTooltipClose}
                    open={open}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                    title={
                      <>
                        <Typography variant="body2" gutterBottom>
                          As you increase the number of homes you mail to, your
                          rate drops.
                        </Typography>
                        <Typography variant="body2" gutterBottom>
                          Minimum 250 number of addresses
                        </Typography>
                        <Typography variant="caption">
                          Up to 349 addresses - $2.272 <br />
                          Up to 499 addresses - $1.785 <br />
                          Up to 749 addresses - $1.420 <br />
                          Up to 999 addresses - $1.136 <br />
                          Up to 1499 addresses - $0.994 <br />
                          Up to 2499 addresses - $0.985 <br />
                          Up to 4999 addresses - $0.875 <br />
                          Up to 9999 addresses - $0.861 <br />
                          Up to 14999 addresses - $0.852 <br />
                          Up to 19999 addresses - $0.825 <br />
                          Up to 24999 addresses - $0.808 <br />
                          Up to 49999 addresses - $0.804 <br />
                          Up to 74999 addresses - $0.797 <br />
                          Up to 999999999 addresses - $0.788
                        </Typography>
                      </>
                    }
                    arrow
                  >
                    <InfoOutlinedIcon onClick={handleTooltipOpen} />
                  </CustomToolTip>
                </div>
              </ClickAwayListener>
            </Stack>
            <Typography>
              &#8722;{totalDiscount ? totalDiscount : '$0'}
            </Typography>
          </Box>
          <Typography variant="caption" color="textSecondary">
            + {quantityUntilNextDiscount ? quantityUntilNextDiscount : 0} more
            addresses until next discount
          </Typography>
          <Box sx={flexBoxContainer}>
            <Typography sx={{ fontWeight: '600' }}>Total Cost</Typography>
            <Typography sx={{ fontWeight: '600' }}>
              {totalCost ? totalCost : '$0'}
            </Typography>
          </Box>
        </>
      )}
    </Stack>
  );
};

export default observer(MapSummary);
